
























































































































import { Component, Watch, Emit, Prop } from "vue-property-decorator";
import { PlyrConfiguration } from "./plyrConfiguration";
import WidgetBase from "../WidgetBase.vue";
import VuePlyr from "vue-plyr";
import { PlyrRef } from "../../../interfaces/plyrRef";
import PlyrUploadScreen from "./UploadScreen.vue";
import { PlyrSource } from "../../../interfaces/plyrSources";
import { PlyrState } from "./plyrState";

@Component({ components: { VuePlyr, PlyrUploadScreen } })
export default class PlyrWidget extends WidgetBase<PlyrConfiguration> {
    plyrTime: number = 0;
    videoTitle: string = "";
    imgWidth: number = 400;
    imgHeight: number = 400;
    volume: number = 0;
    muted: boolean = false;
    @Prop() widgetHeight!: number;

    @Emit() public studioAttributesChanged(
        plyrVideoStartTime: number | null,
        plyrTimeStampAtStartTime: number | null
    ) {
        return {
            plyrVideoStartTime: plyrVideoStartTime,
            plyrTimeStampAtStartTime: plyrTimeStampAtStartTime,
        };
    }

    // only for local state change e.g. customer wants to stop
    public plyrPaused: boolean = true;

    public mounted() {
        if (this.config.state.videoRunning == false) {
            if (this.$store.state.studio.attributes?.plyrVideoStartTime) {
                this.config.state.videoTimestamp = this.$store.state.studio.attributes?.plyrTimeStampAtStartTime;
                this.config.state.currentServerTime = this.$store.state.studio.attributes?.plyrVideoStartTime;
                this.config.state.videoRunning = true;
                this.$refs.plyr.player.currentTime = this.stateTimestamp();
                this.$refs.plyr.player.play();
                this.plyrPaused = false;
            }
        }
    }

    public static get type() {
        return "plyr";
    }

    public $refs!: {
        plyr: Vue & PlyrRef;
    };

    public get sources(): PlyrSource[] {
        return this.config.state.sources || [];
    }
    public set sources(newSources: PlyrSource[]) {
        this.update({
            config: this.config,
            payload: {
                videoTitle: this.videoTitle,
                sources: newSources,
                videoRunning: false,
                videoTimestamp: 0,
            },
        });
    }

    public get plyrType() {
        if (this.sources.some(s => s.size === undefined || s.size === null))
            return "audio";
        else return "video";
    }

    public static get thumbnailAsset() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        return require("@/assets/widget-thumbnails/video-player.svg");
    }

    public get isPresenter(): boolean {
        if (!this.$store.state.studio && this.$store.state.user) {
            return true;
        } else {
            return this.$store.getters.isPresenter;
        }
    }
    public get plyrOptions() {
        if (this.isPresenter) {
            return {
                controls: [
                    "play-large",
                    "progress",
                    "current-time",
                    "mute",
                    "volume",
                    "captions",
                    "settings",
                ],
                keyboard: { focused: false, global: false },
                clickToPlay: false,
                settings: ["captions", "quality"],
            };
        } else
            return {
                controls: ["volume", "mute", "settings", "fullscreen"],
                clickToPlay: false,
                settings: ["captions", "quality"],
                keyboard: { focused: false, global: false },
            };
    }

    public uploadDone(data: { sources: PlyrSource[]; videoTitle: string }) {
        this.videoTitle = data.videoTitle;
        this.sources = data.sources;
    }

    public plyrReady() {
        this.volume = this.$refs.plyr.player.volume;
        this.muted = this.$refs.plyr.player.muted;
        this.$refs.plyr.player.currentTime = this.stateTimestamp();
        if (this.config.state.videoRunning) {
            this.startPlayback();
        }
        this.$refs.plyr.player.on("play", () => {
            this.update({
                config: this.config,
                payload: {
                    videoRunning: true,
                    videoTimestamp: this.$refs.plyr.player.currentTime,
                },
            });
        });
        this.$refs.plyr.player.on("volumechange", () => {
            this.volume = this.$refs.plyr.player.volume;
            this.muted = this.$refs.plyr.player.muted;
        });
        setInterval(() => {
            this.plyrTime = this.$refs.plyr?.player.currentTime;
        }, 1000);
    }

    public endedHandler() {
        this.update({
            config: this.config,
            payload: {
                videoRunning: false,
                videoTimestamp: 0,
            },
        });
    }

    public startPlayback() {
        this.$refs.plyr.player.play();
        this.plyrPaused = false;
    }

    public stopPlayback() {
        this.update({
            config: this.config,
            payload: {
                videoRunning: false,
                videoTimestamp: this.$refs.plyr.player.currentTime,
            },
        });
        this.$refs.plyr.player.pause();
        this.plyrPaused = true;
    }

    @Watch("config.state")
    public onStateChange(newState: PlyrState, oldState: PlyrState) {
        // state detection:
        // newstate -> manual request by presenter OR next slide
        // happens when servertime is present and it's bigger than the last server time
        // else: old slide then keep the "current" state AKA the oldState
        let state: string;
        if (
            (newState.currentServerTime &&
                newState.currentServerTime > oldState.currentServerTime) ||
            (newState.currentServerTime && !oldState.currentServerTime)
        ) {
            state = "reallynewstate";
        } else {
            state = "reallyoldstate";
        }

        if (this.$refs.plyr) {
            if (state == "reallynewstate") {
                if (newState.videoRunning) {
                    this.$refs.plyr.player.currentTime = this.stateTimestamp();
                    this.$refs.plyr.player.play();
                    this.plyrPaused = false;
                    if (this.isPresenter) {
                        this.studioAttributesChanged(
                            this.config.state.currentServerTime,
                            this.$refs.plyr.player.currentTime
                        );
                    }
                }
                if (!newState.videoRunning && newState.currentServerTime) {
                    this.$refs.plyr.player.pause();
                    this.plyrPaused = true;
                    if (this.isPresenter) {
                        this.studioAttributesChanged(null, null);
                    }
                }
            } else if (state == "reallyoldstate") {
                // local change
                this.config.state.videoRunning = oldState.videoRunning;
                this.config.state.videoTimestamp = oldState.videoTimestamp;
                this.config.state.currentServerTime =
                    oldState.currentServerTime;
            }
        }
    }

    public get desynced() {
        return Math.abs(this.plyrTime - this.stateTimestamp()) > 2;
    }

    public stateTimestamp(): number {
        let now = Date.now() / 1000;
        // in case client clock is in the past & scriptbuilder
        if (now < this.config.state.currentServerTime) {
            now = this.config.state.currentServerTime;
        }
        return (
            now -
            this.config.state.currentServerTime +
            this.config.state.videoTimestamp
        );
    }

    public jumpToLive() {
        this.$refs.plyr.player.currentTime = this.stateTimestamp();
    }

    public resize() {
        const widget = this.$parent.$el as HTMLDivElement;
        this.imgWidth = widget.offsetWidth;
        this.imgHeight = widget.offsetHeight - 180;
    }

    public beforeDestroy() {
        if (this.$refs.plyr) {
            this.$refs.plyr.player.destroy();
        }
    }

    public image(name: string) {
        return require(`@/assets/widget-thumbnails/${name}`);
    }
}
